"use client";

import { TChannelInfo } from "@/types/channel";
import { TCommunityInfo } from "@/types/community";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";

interface CommunityContextProps {
	isSidebarMinimized: boolean;
	communityInfo?: TCommunityInfo;
	channelInfo?: TChannelInfo;
	handleMinimizeSidebar: () => void;
}

const CommunityContext = createContext<CommunityContextProps | undefined>(undefined);

export const CommunityProvider = ({
	defaultcommunityInfo,
	defaultchannelInfo,
	children,
}: {
	defaultcommunityInfo?: TCommunityInfo;
	defaultchannelInfo?: TChannelInfo;
	children: ReactNode;
}) => {
	const [channelInfo, setChannelInfo] = useState<TChannelInfo>();
	const [communityInfo, setCommunityInfo] = useState<TCommunityInfo>();
	const [isSidebarMinimized, setIsSidebarMinimized] = useState<boolean>(false);

	useEffect(() => {
		setCommunityInfo(defaultcommunityInfo);
	}, [defaultcommunityInfo]);

	useEffect(() => {
		setChannelInfo(defaultchannelInfo);
	}, [defaultchannelInfo]);

	const handleMinimizeSidebar = () => {
		setIsSidebarMinimized((prevState) => !prevState);
	};

	return (
		<CommunityContext.Provider
			value={{
				channelInfo,
				communityInfo,
				isSidebarMinimized,
				handleMinimizeSidebar,
			}}
		>
			{children}
		</CommunityContext.Provider>
	);
};

export const useCommunityContext = () => {
	const context = useContext(CommunityContext);

	if (!context) {
		throw new Error("useCommunityContext must be used within a CommunityProvider");
	}

	return context;
};
